<template id="modal-template">
  <div v-if="showModal == true" @click.stop>
    <!-- @click="closeModal" -->
    <vs-row>
      <vs-col vs-offset="7">
        <transition name="fade">
          <div class="modal">
            <div class="modal__backdrop">
              <div class="modal__dialog">
                <div class="modal__header">
                  <slot name="header">
                    <h4 style="margin-left: 20px">Manage Bonus Categories</h4>
                    <vue-load-image>
                      <img
                        class="ml-1 topright"
                        slot="image"
                        :src="require('@/assets/images/x/close.png')"
                        height="50"
                        width="47"
                        @click="closeModal"
                      />
                    </vue-load-image>
                  </slot>
                </div>

                <div class="modal__body">
                  <vs-row class="catBgClr mx-4">
                    <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

                    <vs-row>
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-5
                          cursor
                          mt-4
                          mb-3
                          pt-0
                        "
                        @click="addCategory()"
                      >
                        <PlusSquareIcon color="white" />
                        <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                      </div>
                    </vs-row>
                    <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

                    <transition-group type="transition" name="flip-list">
                      <vs-row
                        :key="index"
                        v-for="(category, index) in bonusCategory[bonusindex]
                          .bonus_categories"
                        class="ml-0"
                      >
                        <vs-col
                          vs-lg="9"
                          vs-sm="6"
                          class="pr-6"
                          id="inputBorder"
                        >
                          <vs-row class="ml-5">
                            <vs-col ml-5 vs-lg="12">
                              <div class="my-2 pt-1 ml-1">
                                Category {{ index + 1 }}
                              </div>

                              <select
                                v-if="pointsCategoriesOption.length > 0"
                                v-model="category.points_category"
                                :class="{
                                  'w-full posSelect  pl-3': true,
                                }"
                                @change="handleSelect(index)"
                              >
                                <option
                                  v-for="categor in pointsCategoriesOption"
                                  :key="categor._id"
                                  :value="categor._id"
                                >
                                  {{ categor.name }}
                                </option>
                              </select>
                            </vs-col>
                          </vs-row>
                        </vs-col>
                        <vs-col
                          vs-lg="3"
                          vs-sm="3"
                          vs-type="flex"
                          vs-justify="flex-end"
                        >
                          <div
                            class="
                              flex flex-wrap-reverse
                              items-center
                              cursor
                              mt-5
                              pl-4
                            "
                            @click="removeCategory(index)"
                          >
                            <MinusSquareIcon color="white" class="mt-5" />
                            <div
                              class="addCardFont font-semibold ml-3 cursor mt-6"
                            >
                              Remove
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                    </transition-group>

                    <div
                      v-show="errors.pointCategories.success"
                      class="ml-5 mb-3"
                    >
                      <div id="errFont" class="dangerColor mt-3 ml-1">
                        <span>{{ errors.pointCategories.msg }}</span>
                      </div>
                    </div>
                  </vs-row>

                  <vs-row class="mt-16 pr-2 mb-1" vs-justify="center">
                    <vs-col
                      v-if="
                        bonusCategory[bonusindex].bonus_categories ==
                          undefined ||
                        bonusCategory[bonusindex].bonus_categories.length <= 4
                      "
                      vs-offset="9"
                    >
                      <vs-button
                        style="
                          width: 138px;
                          position: absolute;
                          bottom: 0;
                          margin-bottom: 15px;
                        "
                        @click="saveBonusCategories()"
                        >Save</vs-button
                      >
                    </vs-col>
                    <vs-col
                      v-if="
                        bonusCategory[bonusindex].bonus_categories.length >= 5
                      "
                      vs-offset="9"
                    >
                      <vs-button style="width: 138px">Save</vs-button>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import VueLoadImage from "vue-load-image";
import Datepicker from "vuejs-datepicker";
import draggable from "vuedraggable";
import Editor from "@tinymce/tinymce-vue";
import {
  UploadCloudIcon,
  PlusSquareIcon,
  MinusSquareIcon,
  MenuIcon,
} from "vue-feather-icons";

export default {
  props: ["pointsCategoriesOption", "showModal", "bonusCategory", "bonusindex"],
  data() {
    return {
      field: this.fields,
      menu: false,
      modal: false,
      tempArray: [],
      isfirst: false,
      //pointsCategoriesOption: this.pointsCategoriesOption,
      //bonusCategory: [],
      errors: {
        pointCategories: {
          msg: "",
          success: false,
        },
      },
    };
  },
  methods: {
    async addCategory() {
      //console.log(this.bonusindex);
      if (this.isfirst == false) {
        let a = this.bonusCategory[this.bonusindex].bonus_categories;
        this.tempArray = a;
        this.isfirst = true;
      }
      if (this.bonusCategory[this.bonusindex].bonus_categories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.bonusCategory[this.bonusindex].bonus_categories
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Bonus Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        } else {
          this.errors.pointCategories.msg = "";
          this.errors.pointCategories.success = false;
        }
      }
      await this.bonusCategory[this.bonusindex].bonus_categories.push({
        points_category: "",
      });
      //   console.log(this.bonusCategory);
    },
    handleSelect(data) {},
    async closeModal() {
      if (this.bonusCategory[this.bonusindex].bonus_categories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.bonusCategory[this.bonusindex].bonus_categories
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Bonus Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        } else {
          this.errors.pointCategories.msg = "";
          this.errors.pointCategories.success = false;
        }
      }
      //   console.log(
      //     this.bonusCategory[this.bonusindex].bonus_categories,
      //     this.tempArray
      //   );
      // this.bonusCategory[this.bonusindex].bonus_categories = this.tempArray;
      this.$emit("close_modal_dismiss", false);
    },
    async saveBonusCategories() {
      if (this.bonusCategory[this.bonusindex].bonus_categories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.bonusCategory[this.bonusindex].bonus_categories
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Bonus Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        } else {
          this.errors.pointCategories.msg = "";
          this.errors.pointCategories.success = false;
        }
      }
      this.$emit("close_modal_success", false);
    },
    async removeCategory(index1) {
      this.bonusCategory[this.bonusindex].bonus_categories.splice(index1, 1);
      if (this.bonusCategory[this.bonusindex].bonus_categories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.bonusCategory[this.bonusindex].bonus_categories
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Bonus Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        } else {
          this.errors.pointCategories.msg = "";
          this.errors.pointCategories.success = false;
        }
      }
    },
    async hasCategoryUniqueNames(inp) {
      var tmpArr = [];
      for (var i = 0; i < inp.length; i++) {
        if (tmpArr.indexOf(inp[i].points_category) < 0) {
          tmpArr.push(inp[i].points_category);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      return true;
    },
  },
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    Datepicker,
    Editor,
    draggable,
    MenuIcon,
    VueLoadImage,
  },
  created() {
    this.$emit("fields", this.field);
  },
};
</script>
<style scoped>
.modal {
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal__backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.modal__dialog {
  background-color: #272727;
  width: 650px;
  max-height: 550px;
  min-height: 380px;
  flex-direction: column;
  border-radius: 5px;
  overflow: visible;
  position: fixed;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
}
@media screen and (max-width: 992px) {
  .modal__dialog {
    width: 90%;
    position: fixed;
    left: 50%;
    top: 55%;
    transform: translate(-50%, -50%);
  }
}
.modal__close {
  width: 30px;
  height: 30px;
}
.modal__header {
  overflow: visible;
  padding: 20px 11px 10px;
  background-color: #2c2c2e;
  position: relative;
}
.modal__body {
  padding: 8px 1px;
  width: 650px;
  max-height: 480px;
  min-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  margin-bottom: 20px;
}
</style>